import React, { Component } from "react";
import { Select, Input } from "../../components";
import bg from "../../img/background.webp";
import * as ApiHelper from "../../ApiHelper";
import Util from "../../Util";
import { withRouter } from "react-router-dom";
import * as rd from "diacritics";
import { Loading } from "../../components";
import Style from "../../css/material-dashboard.css";
class LoginForm extends Component {
  constructor() {
    super();
    this.state = {
      cidade: "",
      username: "",
      password: "",
      error: [],
      estados: [{ value: "", label: "" }],
      cidades: [{ value: "", label: "" }],
      showForm: false,
    };
    this.onChangeCidade = this.onChangeCidade.bind(this);
    this.onChangeEstado = this.onChangeEstado.bind(this);
    this.onChangeUserName = this.onChangeUserName.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.sendLoginRequest = this.sendLoginRequest.bind(this);
    this.getStates = this.getStates.bind(this);
    this.getStateByID = this.getStateByID.bind(this);
  }
  componentWillMount() {
    this.getStates();
  }
  getStates() {
    ApiHelper.getStates((states) => {
      if (states) {
        this.setState({
          estados: Util.mapStates(states),
          showForm: true,
        });
      }
    });
  }
  getStateByID(id) {
    var foundState = "";
    this.state.estados.forEach((estado) => {
      if (estado.value === parseInt(id, 10)) {
        foundState = estado;
      }
    });
    return foundState;
  }
  onChangeEstado(event) {
    var stateId = event.target.value;
    var state = this.getStateByID(stateId);
    this.setState({
      error: "",
      cidades: state.cidades,
      estado: stateId,
    });
  }
  onChangeCidade(event) {
    var index = event.nativeEvent.target.selectedIndex;
    var nomeDaCidade = event.nativeEvent.target[index].text;

    this.setState({ error: "", cidade: nomeDaCidade });
  }
  trataErros() {
    var errors = [];
    var cidade = this.state.cidade;
    var username = this.state.username;
    var password = this.state.password;
    if (cidade === "") {
      errors.push("Por favor selecione uma cidade");
    }
    if (username === "") {
      errors.push("Por favor digite seu nome de usuário");
    }
    if (password === "") {
      errors.push("Por favor digite uma senha");
    }
    this.setState({ error: errors });
    if (errors.length === 0) {
      return true;
    } else {
      return false;
    }
  }
  getCityName(city) {
    var cityName = rd.remove(city);
    cityName = cityName.split(" ").join("");
    cityName = cityName.toLowerCase();
    console.log(cityName);
    if (cityName === "barroquinha") {
      cityName = "pbarroquinha";
    }
    console.log(cityName);
    return cityName;
  }
  sendLoginRequest(event) {
    event.preventDefault();
    if (this.trataErros()) {
      localStorage.setItem("cidade", this.state.cidade);
      var cidade = this.getCityName(this.state.cidade);
      console.log(cidade);
      ApiHelper.login(
        cidade,
        this.state.username,
        this.state.password,
        (error) => {
          if (error) {
            this.setState({ error: error });
          } else {
            ApiHelper.getMe((errorMe) => {
              if (errorMe) {
                this.setState({ error: "Login ou senha inválidos" });
                localStorage.setItem("token", "");
              } else {
                this.props.history.push("/");
              }
            });
          }
        }
      );
    }
  }
  onChangeUserName(event) {
    this.setState({ error: [] });
    var newInputText = event.target.value;
    this.setState({ error: "", username: newInputText });
  }
  onChangePassword(event) {
    this.setState({ error: [] });
    var newInputText = event.target.value;
    this.setState({ error: "", password: newInputText });
  }
  render() {
    if (!this.state.showForm) {
      return <Loading />;
    }
    return (
      <div>
        <div
          className="bg"
          style={{
            backgroundImage: "url(" + bg + ")",
          }}
        >
          <div className="login vertical-center-row col-md-offset-3 col-md-6 col-lg-4 col-lg-offset-4 col-sm-8 col-sm-offset-2 col-xs-12">
            <form onSubmit={this.sendLoginRequest}>
              <div
                className="card card-login"
                style={{
                  marginTop: '15%',
                }}
              >
                <div
                  className="card-header text-center"
                  data-background-color="as-blue"
                >
                  <h4 className="card-title">Sistema de gestão de contratos</h4>
                </div>
                <div className="card-content">
                  <Select
                    options={this.state.estados}
                    icon="account_balance"
                    label="Estado"
                    name="estado"
                    onChange={this.onChangeEstado}
                  />
                  <Select
                    options={this.state.cidades}
                    icon="location_city"
                    label="Cidade"
                    name="cidade"
                    onChange={this.onChangeCidade}
                  />
                  <Input
                    onChange={this.onChangeUserName}
                    icon="face"
                    label="Nome de usuário"
                    name="username"
                    autocomplete="username"
                    type="text"
                  />
                  <Input
                    onChange={this.onChangePassword}
                    icon="lock"
                    label="Senha"
                    autocomplete="current-password"
                    name="password"
                    type="password"
                  />
                  <br />
                  {this.state.error.length !== 0 && (
                    <div className="alert alert-danger">{this.state.error}</div>
                  )}
                </div>
                <div className="footer text-center">
                  <button
                    type="submit"
                    className="btn btn-rose btn-simple btn-wd btn-lg"
                  >
                    Entrar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(LoginForm);



// WEBPACK FOOTER //
// ./src/views/auth/LoginForm.js